<script setup>
import EvalBuilderView from '@/pages/eval/eval-builder/EvalBuilderView.vue';
</script>

<template>
  <EvalBuilderView evalType="agentic" />
</template>

